
import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
@Component
export default class publicTable extends Vue {
    data = []
    @Prop()
    row
    @Prop()
    columns
}
